export default __webpack_public_path__ + "static/python-hands-on-project-6afe663d68adb5d534c655289e6ea3d0.webp";